import React, { useState } from 'react';
import GroupedApplicationsInternalExpert from './GroupedApplicationsInternalExpert';
import InExpertiseApplicationsInternalExpert from './InExpertiseApplicationsInternalExpert';

const TABS = {
  kz: [
    { key: 'new',        label: 'Жаңа өтінімдер' },
    { key: 'inExpertise', label: 'Сараптамада' },
  ],
  ru: [
    { key: 'new',        label: 'Новые заявки' },
    { key: 'inExpertise', label: 'На экспертизе' },
  ],
};

export default function InternalExpertHub({ locale }) {
  const [activeKey, setActiveKey] = useState('new');
  const tabs = TABS[locale] || TABS.ru;

  return (
    <section className="dashboard-body">
      {/* Переключатель вкладок */}
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: 4,
          background: '#e2e8f0',
          borderRadius: 8,
          padding: 4,
          marginBottom: 20,
          width: 'fit-content',
        }}
      >
        {tabs.map((tab) => {
          const isActive = activeKey === tab.key;
          return (
            <button
              key={tab.key}
              type="button"
              onClick={() => setActiveKey(tab.key)}
              style={{
                padding: '8px 20px',
                borderRadius: 6,
                border: 'none',
                cursor: 'pointer',
                fontWeight: isActive ? 600 : 400,
                fontSize: 13,
                background: isActive ? '#fff' : 'transparent',
                color: isActive ? '#0f172a' : '#64748b',
                boxShadow: isActive ? '0 1px 3px rgba(0,0,0,0.12)' : 'none',
                transition: 'all 0.15s',
                whiteSpace: 'nowrap',
              }}
            >
              {tab.label}
            </button>
          );
        })}
      </div>

      {/* Контент */}
      {activeKey === 'new'
        ? <GroupedApplicationsInternalExpert locale={locale} />
        : <InExpertiseApplicationsInternalExpert locale={locale} />
      }
    </section>
  );
}